import React, { FC, useEffect, useState } from 'react';
import cn from 'classnames';
import { Title } from '../Title';
import { Typography } from '../Typography';
import { Button } from '../Button';
import { Badge } from '../Badge';
import { Image } from '../Image';
import { declineMessage } from '../../_internal_/utils/declineMessage';
import { ITitleTags } from '../Title';
import DEFAULT_IMAGE from './ChatPanel.assets/no-photo.png';
require("./ChatPanel.css");
var styles = {
  "Root": "ChatPanel-module-Root_2UA",
  "sSize": "ChatPanel-module-sSize_1wE",
  "mSize": "ChatPanel-module-mSize_2Uz",
  "lSize": "ChatPanel-module-lSize_3YZ",
  "Title": "ChatPanel-module-Title_u2d",
  "Preview": "ChatPanel-module-Preview_3hz",
  "Chat": "ChatPanel-module-Chat_1jy",
  "Operator": "ChatPanel-module-Operator_2BM",
  "Status": "ChatPanel-module-Status_3AM",
  "Photo": "ChatPanel-module-Photo_192",
  "Online": "ChatPanel-module-Online_MV4",
  "Image": "ChatPanel-module-Image_3w_",
  "Button": "ChatPanel-module-Button_2Vr"
};
const DEFAULT_WORDS = ['сообщение', 'сообщения', 'сообщений'];
export const ChatPanelSizes = {
  s: 's',
  m: 'm',
  l: 'l'
};
export const ChatPanel = ({
  className,
  online,
  photoSrc,
  size = 'm',
  title,
  titleSize = 'h3',
  onOpenChat,
  quantityMessage
}) => {
  const [newMessage, setNewMessage] = useState('');
  useEffect(() => {
    if (quantityMessage) {
      const res = `${quantityMessage} ${declineMessage(quantityMessage, DEFAULT_WORDS)}`;
      setNewMessage(res);
    } else {
      setNewMessage('');
    }
  }, [newMessage, quantityMessage]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, styles[`${size}Size`], className)
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Preview
  }, /*#__PURE__*/React.createElement(Title, {
    tag: titleSize,
    className: styles.Title
  }, title), newMessage && /*#__PURE__*/React.createElement(Badge, {
    content: newMessage,
    className: styles.Message
  })), /*#__PURE__*/React.createElement("div", {
    className: styles.Chat
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Operator
  }, /*#__PURE__*/React.createElement("div", {
    className: `${styles.Photo} ${online ? styles.Online : ''}`
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.Image
  }, /*#__PURE__*/React.createElement(Image, {
    src: photoSrc ? photoSrc : DEFAULT_IMAGE,
    alt: ""
  }))), /*#__PURE__*/React.createElement(Typography, {
    className: styles.Status,
    tag: "p",
    variant: "p2"
  }, `Фармацевт ${online ? 'онлайн' : 'офлайн'}`)), /*#__PURE__*/React.createElement(Button, {
    onClick: onOpenChat,
    className: styles.Button,
    type: "button",
    variant: "filled",
    fullWidth: true
  }, "\u0412 \u0447\u0430\u0442")));
};